import { useEffect, useState } from "react";
import PreviousCareRepeaterItem from "./PreviousCareRepeaterItem";
import Button from "../../../../../common/Button";
import classes from './PreviousCareRepeater.module.css'
import { caseQuickUpdate } from "../../../../../../lib/fetchApi";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../../../../../store/notifications";
import { caseActions } from "../../../../../../store/case";
import { useUserTabEditPermissionDisabled } from "../../../../../../lib/usersPermissions";

const DEFAULT_PREVIOUS_CARE_GROUPS = [{ id: 1, data: {} }]

function normalizePrevCareList(prevCareList) {
    if (Array.isArray(prevCareList) && prevCareList.length > 0) {
        return prevCareList
    }
    return DEFAULT_PREVIOUS_CARE_GROUPS
}

export default function PreviousCareRepeater({apiCase, permissionType}) {
    let userPermissionDenied = useUserTabEditPermissionDisabled(permissionType) 
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const [numberOfGroups, setNumberOfGroups] = useState(() =>
        normalizePrevCareList(activeCase?.additional?.prev_care_list)
    )

    const [updateFlag, setUpdateFlag] = useState(0)

    function addRepeaterItemHandler(newIndex) {
        let newItem = {
            id: newIndex,
            data: {}
        }
        setNumberOfGroups((prev) => [...prev, newItem])
        setUpdateFlag((prev) => prev + 1)
    }

    function removeRepeaterItemHandler(index) {
        setNumberOfGroups((prev) => prev.filter((item) => item.id != index))
        setUpdateFlag((prev) => prev + 1)
    }

    function addItemDataHandler(value) {
        if (value.data.value && value.identifier.field && value.identifier.repeater_id) {            
            setNumberOfGroups(prev => prev.map(item => {
                if (item.id == value.identifier.repeater_id) {
                    return {
                        id: value.identifier.repeater_id,
                        data: {
                            ...item.data,
                            [value.identifier.field]: value.data.value
                        }
                    }
                } else {
                    return item
                }
            }))
            setUpdateFlag(prev => prev + 1)
        }
    }
    
    // Persist only after real edits. On mount, `prev_care_list` vs local state often differ by
    // reference (`!=` on arrays) or default placeholder vs missing API field — that must not call quick-update.
    useEffect(() => {
        if (updateFlag === 0) {
            return
        }
        async function setPreviousCare() {
            let reqBody = {
                type: apiCase,
                fields: {
                    prev_care_list: numberOfGroups,
                },
            }
            const caseId = activeCase?.case?.id
            if (!caseId) {
                return
            }
            let response = await caseQuickUpdate(userToken, caseId, reqBody)
            if (response && response.errorMessage) {
                dispatch(notificationActions.setError(response))
            } else {
                let dispatchObj = {
                    folder: 'additional',
                    item: {
                        fields: [
                            {
                                field: 'prev_care_list',
                                value: numberOfGroups,
                            },
                        ],
                    },
                }

                setTimeout(() => {
                    dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
                }, 0)
                setUpdateFlag(0)
            }
        }
        setPreviousCare()
        // Intentionally only `updateFlag`: including `numberOfGroups` would re-fire after Redux
        // syncs `prev_care_list` from the same save and loop duplicate quick-updates.
    }, [updateFlag])


    useEffect(() => {
        const prevCareList = activeCase?.additional?.prev_care_list
        if (Array.isArray(prevCareList) && prevCareList.length > 0) {
            setNumberOfGroups(prevCareList)
        }
    }, [activeCase?.additional?.prev_care_list])

    return <div>

        {numberOfGroups && numberOfGroups.map((groupRepeater, index) => (
            <div key={index} className={classes.item_wrapper}>
                <PreviousCareRepeaterItem id={groupRepeater.id} addItemData={addItemDataHandler} itemData={groupRepeater?.data}/>
                {!userPermissionDenied && <>
                    {index == numberOfGroups.length-1 ? <div>
                            <Button click={addRepeaterItemHandler.bind(this, groupRepeater.id+1)} title={'Add new item'}><i className="ti ti-plus"></i></Button>
                        </div>
                        :
                        <div>
                            <Button click={removeRepeaterItemHandler.bind(this, groupRepeater.id)} title={'Remove item'} btnStyle={'btn_white'}><i className="ti ti-minus"></i></Button>
                        </div>
                    }
                </>}
            </div>
            
        ))}

        
    </div>
}